import React, { useState } from 'react';
import { storage, db } from '../firebase'; // Importez votre configuration Firebase
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import NavbarAdmin from '../components/NavbarAdmin'; // Importez NavbarAdmin

const AddProject = () => {
  const [title, setTitle] = useState('');
  const [zone, setZone] = useState('');
  const [duration, setDuration] = useState('');
  const [startDate, setStartDate] = useState('');
  const [budget, setBudget] = useState('');
  const [globalObjective, setGlobalObjective] = useState('');
  const [specificObjectives, setSpecificObjectives] = useState('');
  const [bailleur, setBailleur] = useState(''); // Nouvel input pour 'bailleur'
  const [photo, setPhoto] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false); // État de la case à cocher
  const [uploading, setUploading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch(name) {
      case 'title': setTitle(value); break;
      case 'zone': setZone(value); break;
      case 'duration': setDuration(value); break;
      case 'startDate': setStartDate(value); break;
      case 'budget': setBudget(value); break;
      case 'globalObjective': setGlobalObjective(value); break;
      case 'specificObjectives': setSpecificObjectives(value); break;
      case 'bailleur': setBailleur(value); break; // Gérer la modification de 'bailleur'
      default: break;
    }
  };

  const handleFileChange = (e) => {
    setPhoto(e.target.files[0]); // Capturer le fichier unique
  };

  const handleCheckboxChange = (e) => {
    setIsCompleted(e.target.checked); // Définir l'état en fonction de la case à cocher
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      let photoUrl = '';

      // Téléverser la photo si elle est sélectionnée
      if (photo) {
        const photoRef = ref(storage, `projects/${photo.name}`);
        await uploadBytes(photoRef, photo);
        photoUrl = await getDownloadURL(photoRef);
      }

      // Ajouter le document à Firestore
      await addDoc(collection(db, 'projects'), {
        title,
        zone,
        duration,
        startDate,
        budget: parseFloat(budget), // Convertir le budget en float
        globalObjective,
        specificObjectives,
        bailleur, // Ajouter le bailleur
        photo: photoUrl,
        status: isCompleted ? 1 : 0, // Utiliser 1 pour terminé, 0 pour non terminé
        timestamp: Timestamp.now(),
      });

      alert('Projet ajouté avec succès !');
      // Réinitialiser le formulaire
      setTitle('');
      setZone('');
      setDuration('');
      setStartDate('');
      setBudget('');
      setGlobalObjective('');
      setSpecificObjectives('');
      setBailleur(''); // Réinitialiser le champ 'bailleur'
      setPhoto(null);
      setIsCompleted(false);
    } catch (error) {
      console.error('Erreur lors de l\'ajout du document : ', error);
    } finally {
      setUploading(false);
    }
  };

  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '2rem',
    color:  '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0 auto',
    maxWidth: '600px',
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%', // Augmenter la largeur à 100%
    boxSizing: 'border-box', // Assurer que le padding et la bordure sont inclus dans la largeur totale de l'élément
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: '100px',
  };

  const fileInputStyle = {
    ...inputStyle,
    padding: '8px',
    border: '1px solid #ddd',
    height: 'auto', // S'assurer que la hauteur s'adapte au contenu
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor:  '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const buttonDisabledStyle = {
    ...buttonStyle,
    backgroundColor: '#999',
    cursor: 'not-allowed',
  };

  return (
    <div>
      <NavbarAdmin />
      <div style={containerStyle}>
        <h2 style={headingStyle}>Ajouter un Projet</h2>
        <form onSubmit={handleSubmit} style={formStyle}>
          <label>
            Titre :
            <input
              type="text"
              name="title"
              value={title}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Zone d'intervention :
            <input
              type="text"
              name="zone"
              value={zone}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Durée :
            <input
              type="text"
              name="duration"
              value={duration}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Date début :
            <input
              type="date"
              name="startDate"
              value={startDate}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Budget :
            <input
              type="number"
              name="budget"
              value={budget}
              onChange={handleInputChange}
              required
              style={inputStyle}
              step="0.01" // Permet les valeurs décimales
            />
          </label>
          <label>
            Objectif global :
            <input
              type="text"
              name="globalObjective"
              value={globalObjective}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Objectifs spécifiques :
            <textarea
              name="specificObjectives"
              value={specificObjectives}
              onChange={handleInputChange}
              required
              style={textareaStyle}
            />
          </label>
          <label>
            Bailleur :
            <input
              type="text"
              name="bailleur"
              value={bailleur}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Photo :
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={fileInputStyle}
            />
          </label>
          <label>
            Terminé :
            <input
              type="checkbox"
              checked={isCompleted}
              onChange={handleCheckboxChange}
            />
          </label>
          <button
            type="submit"
            disabled={uploading}
            style={uploading ? buttonDisabledStyle : buttonStyle}
          >
            {uploading ? 'Téléchargement en cours...' : 'Ajouter le Projet'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProject;
